import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { IONIC_CONFIG } from './core/ionic-config';

// Capa `compat` de AngularFire: misma API que la v5, sobre firebase 11. Migrar a la
// API modular es un cambio aparte, no de esta migracion.
import { AngularFireModule } from '@angular/fire/compat';

import { environment } from 'src/environments/environment';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { SelectDriversPageModule } from './pages/select-drivers/select-drivers.module';
import { RejectOrderPageModule } from './pages/reject-order/reject-order.module';
import { PreviewPageModule } from './pages/preview/preview.module';
import { NewOrderPageModule } from './pages/new-order/new-order.module';
import { SideNavModule } from './components/side-nav/side-nav.module';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

export function customTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    IonicModule.forRoot(IONIC_CONFIG),
    // AngularFirestore, AngularFireAuth y AngularFireStorage son `providedIn: 'any'`:
    // se inyectan sin declarar sus modulos. AngularFireDatabaseModule ademas sobraba,
    // esta app no usa Realtime Database.
    AngularFireModule.initializeApp(environment.firebase),
    AppRoutingModule,
    HttpClientModule,
    SelectDriversPageModule,
    RejectOrderPageModule,
    PreviewPageModule,
    NewOrderPageModule,
    SideNavModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: customTranslateLoader,
        deps: [HttpClient]
      }
    })
  ],
  providers: [{ provide: RouteReuseStrategy, useClass: IonicRouteStrategy }],
  bootstrap: [AppComponent]
})
export class AppModule {}
